import deltaLogo from "../assets/icons/partners/delta.png";

export const companyData = {
  companyName: "Coretech",
  email: "info@coretechpal.com",
  website: "www.coretechpal.com",
  address: {
    en: "4th Floor, Mecca Mall Building, Rafeedia Street, Nablus, Palestine",
    ar: "الطابق الرابع، مبنى ميغا مول، شارع رفيديا، نابلس، فلسطين",
  },

  description: {
    en: " Coretech is an end-to-end reseller and service provider in the sectors of Telecommunications and ICT, Coretech always keen to enhance its' customers experience through providing the latest technology in the market, revolutionize the telecommunications and IT industry through innovative solutions that connect the world and empower human potential. We envision a future where deploying cutting-edge technology enhances lives, businesses, and societies. With a relentless commitment to excellence, integrity, and customer satisfaction, we aspire to be the leading provider of the best in Line telecommunications and IT services, by setting new standards of reliability, efficiency, and sustainability, and pushing the boundaries of innovation and creativity.",
    ar:
      "كورتيك (Coretech) هي شركة رائدة تعمل كموزّع ومزوّد خدمات متكامل في مجالي الاتصالات وتقنية المعلومات (ICT)، تقدّم حلولًا شاملة من البداية إلى النهاية. نلتزم في كورتيك بالارتقاء بتجربة عملائنا عبر توفير أحدث التقنيات المتقدمة في السوق، وتقديم حلول مبتكرة تُحدث نقلة نوعية في عالم الاتصالات وتقنية المعلومات، وتربط العالم بسلاسة، وتُطلق العنان للإمكانات البشرية." +
      "نؤمن بمستقبل تقوده التكنولوجيا الذكية، حيث يسهم توظيف الحلول المتطورة في تحسين جودة الحياة، وتعزيز نمو الأعمال، وبناء مجتمعات أكثر تطورًا واستدامة. ومن خلال التزامنا المستمر بالتميّز، والنزاهة، وتركيزنا المطلق على رضا العملاء، نسعى لأن نكون الشريك الموثوق والاختيار الأول في تقديم خدمات الاتصالات وتقنية المعلومات، عبر وضع معايير جديدة للموثوقية والكفاءة والاستدامة، ودفع حدود الابتكار والإبداع نحو آفاق غير مسبوقة.",
  },

  vision: {
    en: "At Coretech, our vision is to revolutionize the telecommunications and IT industry through innovative solutions that connect the world and empower human potential. We envision a future where cutting-edge technology enhances lives, businesses, and societies, while setting new standards of reliability, efficiency, and sustainability.",
    ar: "تتمثل رؤيتنا في كورتيك في إحداث نقلة نوعية في قطاع الاتصالات وتقنية المعلومات من خلال حلول مبتكرة تربط العالم وتعزز الإمكانات البشرية. نطمح إلى مستقبل تُسهم فيه أحدث التقنيات في تحسين حياة الأفراد، وتطوير الأعمال، ودعم المجتمعات، مع وضع معايير جديدة في الموثوقية والكفاءة والاستدامة.",
  },

  mission: {
    en: "Our mission is to deliver cutting-edge telecommunications and IT solutions that empower businesses and individuals to thrive. We are committed to providing innovative products, reliable services, and exceptional customer experiences through continuous research and investment in emerging technologies.",
    ar: "رسالتنا هي تقديم حلول متقدمة في مجال الاتصالات وتقنية المعلومات تمكّن الشركات والأفراد من تحقيق النجاح والنمو. نلتزم بتوفير منتجات مبتكرة، وخدمات موثوقة، وتجارب استثنائية للعملاء من خلال البحث المستمر والاستثمار في التقنيات الناشئة.",
  },
  products: [
    {
      category: {
        en: "Fixed Line Telecommunications",
        ar: "اتصالات الخطوط الثابتة",
      },
      items: [
        {
          title: {
            en: "Wooden Poles",
            ar: "الأعمدة الخشبية",
          },
          description: {
            en: "Through the years, we have established relationships with multiple suppliers across eastern and northern Europe. Our wooden poles range from 7m to 16m, made from Scots Pine wood and treated with environmentally friendly Tanalith-E.",
            ar: "على مدار السنوات، قمنا ببناء علاقات قوية مع موردين في شرق وشمال أوروبا. تتراوح أعمدة الخشب لدينا من 7 إلى 16 مترًا، مصنوعة من خشب الصنوبر الاسكتلندي ومعالجة بمواد صديقة للبيئة.",
          },
        },
        {
          title: {
            en: "Fiber Cables and Accessories",
            ar: "كوابل الألياف الضوئية وملحقاتها",
          },
          description: {
            en: "Complete OSP network components including fiber cables, patch cords, splitters, ducts, splice closures, and distribution boxes.",
            ar: "مكونات متكاملة لشبكات الألياف الضوئية تشمل الكوابل، والوصلات، والمقسمات، والقنوات، وصناديق التوزيع.",
          },
        },
        {
          title: {
            en: "FTTx Core Network",
            ar: "الشبكات الأساسية FTTx",
          },
          description: {
            en: "End-to-end solutions for GPON, XGPON, and XSGPON networks from industry leaders.",
            ar: "حلول متكاملة لشبكات GPON و XGPON و XSGPON من كبرى الشركات العالمية.",
          },
        },
        {
          title: {
            en: "Tools and Testing Equipment",
            ar: "أدوات ومعدات الفحص",
          },
          description: {
            en: "Professional installation tools and testing equipment from leading manufacturers.",
            ar: "أدوات تركيب ومعدات فحص احترافية من أفضل الشركات العالمية.",
          },
        },
        {
          title: {
            en: "GIS and Project Management Software",
            ar: "برمجيات نظم المعلومات الجغرافية وإدارة المشاريع",
          },
          description: {
            en: "Advanced GIS and project tracking software for telecom infrastructure projects.",
            ar: "برمجيات متقدمة لإدارة المشاريع وتتبع البنية التحتية للاتصالات.",
          },
        },
        {
          title: {
            en: "ONUs and Access Points",
            ar: "وحدات الشبكة ونقاط الوصول",
          },
          description: {
            en: "High-speed WiFi 7 products reaching up to 10Gb/s from global vendors.",
            ar: "منتجات WiFi 7 عالية السرعة تصل إلى 10 جيجابت/ثانية من موردين عالميين.",
          },
        },
        {
          title: {
            en: "Steel Structures for Radio Towers",
            ar: "الهياكل الفولاذية لأبراج الاتصالات",
          },
          description: {
            en: "High-quality steel structures designed for radio and telecom towers.",
            ar: "هياكل فولاذية عالية الجودة مخصصة لأبراج الاتصالات والبث.",
          },
        },
        {
          title: {
            en: "DMR Radio Solutions",
            ar: "حلول أجهزة DMR",
          },
          description: {
            en: "Digital Mobile Radio (DMR) solutions including handheld radios, mobile radios, repeaters, and complete radio systems for reliable and secure communications.",
            ar: "حلول الاتصالات الرقمية DMR تشمل أجهزة محمولة ومركبية، ومكررات وأنظمة متكاملة لضمان اتصال موثوق وآمن.",
          },
        },
        {
          title: {
            en: "TETRA Radio Systems",
            ar: "أنظمة اتصالات TETRA",
          },
          description: {
            en: "Mission-critical TETRA communication systems designed for public safety, transportation, and large-scale operations.",
            ar: "أنظمة اتصالات TETRA مصممة للمهام الحرجة مثل السلامة العامة، النقل، والعمليات واسعة النطاق.",
          },
        },
        {
          title: {
            en: "PTT over Cellular (PoC)",
            ar: "الاتصال عبر الشبكات الخلوية (PoC)",
          },
          description: {
            en: "Push-To-Talk over cellular solutions enabling instant communication over 4G/5G and WiFi networks.",
            ar: "حلول الاتصال الفوري عبر الشبكات الخلوية 4G/5G وWiFi باستخدام تقنية الضغط للتحدث (PoC).",
          },
        },
        {
          title: {
            en: "Broadband Terminals & Systems",
            ar: "الأنظمة والمحطات ذات النطاق العريض",
          },
          description: {
            en: "Broadband communication terminals and systems providing high-speed data, video, and voice services.",
            ar: "محطات وأنظمة اتصال عريضة النطاق توفر خدمات البيانات والفيديو والصوت بسرعات عالية.",
          },
        },
        {
          title: {
            en: "Body Worn Cameras",
            ar: "كاميرات تُرتدى على الجسم",
          },
          description: {
            en: "Professional body worn cameras integrated with evidence management systems for security and law enforcement.",
            ar: "كاميرات احترافية تُرتدى على الجسم ومتكاملة مع أنظمة إدارة الأدلة للجهات الأمنية.",
          },
        },
        {
          title: {
            en: "Two-Way Radio Types",
            ar: "أنواع أجهزة الاتصال اللاسلكي",
          },
          description: {
            en: "Wide range of analogue, licence-free, and ATEX intrinsically safe radios for different working environments.",
            ar: "مجموعة متنوعة من أجهزة الاتصال التناظرية، بدون ترخيص، وأجهزة ATEX الآمنة للاستخدام في البيئات الخطرة.",
          },
        },
        {
          title: {
            en: "Integrated Communication Solutions",
            ar: "حلول اتصالات متكاملة",
          },
          description: {
            en: "End-to-end solutions including emergency systems, smart city CCTV, bi-directional amplifiers, site infrastructure, and accessories.",
            ar: "حلول متكاملة تشمل أنظمة الطوارئ، كاميرات المدن الذكية، مضخمات الإشارة ثنائية الاتجاه، البنية التحتية، والملحقات.",
          },
        },
        {
          title: {
            en: "Quail Wearable Communication Devices",
            ar: "أجهزة كوايل للاتصال القابل للارتداء",
          },
          description: {
            en: "A range of wearable communication devices designed for healthcare, retail, and quick service environments. The lineup includes Pro11 for healthcare, Pro12 for retail, and Pro9 for quick service, enabling instant, hands-free, and reliable team communication.",
            ar: "مجموعة من أجهزة الاتصال القابلة للارتداء من كوايل، مصممة لقطاعات الرعاية الصحية، البيع بالتجزئة، والخدمة السريعة. تشمل السلسلة Pro11 للرعاية الصحية، Pro12 للبيع بالتجزئة، وPro9 للخدمة السريعة، وتوفر تواصلاً فورياً وموثوقاً دون استخدام اليدين.",
          },
        },
      ],
    },
  ],

  services: [
    {
      category: {
        en: "ICT Solutions",
        ar: "حلول تقنية المعلومات",
      },
      provider: "Delta Line International (DLI)",
      website: "https://deltaline-it.com/",
      logo: deltaLogo,
      description: {
        en: "Leading Cyber Security Company over GCC since 2006, providing IT security with high quality service and up-to-date technology.",
        ar: "شركة رائدة في مجال الأمن السيبراني في دول الخليج منذ عام 2006، تقدم حلول أمن معلومات عالية الجودة باستخدام أحدث التقنيات.",
      },
      offerings: [
        { en: "Endpoint Security", ar: "أمن الأجهزة الطرفية" },
        { en: "Network Security", ar: "أمن الشبكات" },
        { en: "Data Security", ar: "أمن البيانات" },
        { en: "Security Assessment", ar: "تقييم المخاطر الأمنية" },
        { en: "Access Control", ar: "التحكم في الوصول" },
        { en: "End-user Education", ar: "توعية المستخدمين" },
        {
          en: "Enterprise Cybersecurity Services",
          ar: "خدمات الأمن السيبراني للمؤسسات",
        },
        {
          en: "Specialized Cyber Security Solutions",
          ar: "حلول أمن سيبراني متخصصة",
        },
        {
          en: "Security Monitoring and Reporting",
          ar: "مراقبة وإعداد التقارير الأمنية",
        },
        { en: "IT Optimization", ar: "تحسين أنظمة تقنية المعلومات" },
        {
          en: "Data and Email Backup",
          ar: "نسخ احتياطي للبيانات والبريد الإلكتروني",
        },
      ],
      partners: [
        "Malwarebytes",
        "Kaspersky",
        "SolarWinds",
        "Palo Alto Networks",
        "Stratodesk",
        "Trend Micro",
      ],
    },
  ],

  clients: [
    { name: "SELCO", logo: "SELCO" },
    { name: "Jawal", logo: "Jawal" },
    { name: "JDECO", logo: "JDECO" },
    { name: "PALTEL", logo: "PALTEL" },
    { name: "UNWRWA", logo: "UNWRWA" },
    { name: "NEDCO", logo: "NEDCO" },
    {
      name: "An-Najah National University",
      logo: "An-Najah National University",
    },
    { name: "Ramallah Municipality", logo: "RAMALLAH1908" },
    { name: "PARC", logo: "PARC" },
    { name: "Ooredoo", logo: "Ooredoo" },
  ],

 
};
